import * as locale from 'locale-codes';
import { ILocale } from 'src/typings/locale';

export const FormatedPrice = {
  getFormatedPrice(price: number, countryCode: string): {locale: string[], formatedPrice: string} {
    const matches = locale.all.filter((l) => l.tag.match(countryCode));
    const codesArray = matches.map((l) => l.tag);
    const localesArray = codesArray.length ? codesArray : ['uk-UA'];
    const formatedPrice = new Intl.NumberFormat(localesArray).format(price);
    return {
      locale: localesArray,
      formatedPrice,
    };
  },

  formatNumberWithLocaleSeparator(countryCode: string): ILocale {
    const formatedPriceObj = this.getFormatedPrice(1234567.89, countryCode);
    const nonDigits = formatedPriceObj.formatedPrice.replace(/\d/g, '');
    const groupSeparator = nonDigits.length > 1 ? nonDigits[0] : ' ';
    const decimalSeparator = nonDigits.length > 1
      ? nonDigits[nonDigits.length - 1]
      : ',';
    return {
      locale: formatedPriceObj.locale,
      groupSeparator,
      decimalSeparator,
    };
  },
};
